<script setup>
import Icon from '@/Components/Icon/index.vue';
import Heading from '@/Components/Heading.vue';
import { computed } from 'vue';

const props = defineProps({
  scholarship: {
    type: Object,
    required: true,
  }
});

const levelsOfStudy = computed(() => {
  if(!props.scholarship.level_of_studies.length) {
    return null;
  }
  return props.scholarship.level_of_studies.map((los) => {
    return los.name;
  })
  .join(', ');
});
</script>

<template>
  <div>
    <p class="ext-sm mb-2 flex align-items-center">
      The scholarship you're interested in...
    </p>
    <Heading
      size="h3"
      style-size="h3"
    >
      <strong><a
        :href="`/scholarship/${scholarship.slug}/${scholarship.id}`"
        class="border-none"
      >{{ scholarship.name }}</a></strong>
    </Heading>
    <p
      v-if="scholarship.amount_annual"
      class="text-sm mb-2 flex align-items-center"
    >
      <Icon
        class="me-2"
        path="DollarSquare"
        :height="16"
        :width="16"
      />Award value - ${{ scholarship.amount_annual }} annually
    </p>
    <p
      v-if="levelsOfStudy"
      class="text-sm mb-2 flex align-items-center"
    >
      <Icon
        class="me-2"
        path="Book"
        :height="16"
        :width="16"
      />Level of study - {{ levelsOfStudy }}
    </p>
    <p
      v-if="scholarship.country_of_citizenship.name"
      class="text-sm mb-2 flex align-items-center"
    >
      <Icon
        class="me-2"
        path="Flag"
        :height="16"
        :width="16"
      />Nationality - {{ scholarship.country_of_citizenship.name }}
    </p>
    <p
      v-if="scholarship.closing_date"
      class="text-sm mb-2 flex align-items-center"
    >
      <Icon
        class="me-2"
        path="Calendar"
        :height="16"
        :width="16"
      />Closing date - {{ scholarship.closing_date }}
    </p>
  </div>
</template>
